// src/components/BrowseRange.jsx
export default function BrowseRange() {
  const items = [
    { src: "/images/Mask Group (2).png", label: "Dining" },
    { src: "/images/Image-living room.png", label: "Living" },
    { src: "/images/Mask Group (3).png", label: "Bedroom" },
  ];

  return (
    <section id="browse" className="bg-white">
      <div
        className="mx-auto max-w-6xl px-6 py-12"
        style={{ fontFamily: "Montserrat, ui-sans-serif, system-ui" }}
      >
        <h2 className="text-center text-2xl md:text-3xl font-extrabold text-gray-900">
          Browse The Range
        </h2>
        <p className="text-center text-gray-500 mt-2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(({ src, label }) => (
            <article
              key={label}
              className="bg-white rounded-2xl shadow-sm overflow-hidden"
            >
              <img
                src={src}
                alt={label}
                loading="lazy"
                className="w-full h-56 sm:h-64 md:h-72 object-cover"
              />
              <div className="py-3">
                <p className="text-center text-gray-900 font-semibold">{label}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
